import moment from 'moment'
import {filter, pluck, propEq} from 'ramda'

export const setLastAndNextExportDatesForScheduledExport = (exportData) => {
  let currentDate = moment()
  let scheduleDate = moment(exportData.scheduleStartDate)
  if (scheduleDate.isSame(currentDate, 'day')) {
    exportData['lastExportDate'] = scheduleDate.format('YYYY-MM-DD')
    exportData['nextExportDate'] = getNextExportDate(exportData.schedule, scheduleDate).format('YYYY-MM-DD')
  } else if (scheduleDate.isAfter(currentDate)) {
    exportData['lastExportDate'] = ''
    exportData['nextExportDate'] = scheduleDate.format('YYYY-MM-DD')
  } else {
    // throw error since schedule is not less than current date
  }
}

const getNextExportDate = (schedule, scheduleDate) => {
  switch (schedule) {
    case 'Daily':
      return scheduleDate.add(1, 'days')
    case 'Weekly':
      return scheduleDate.add(7, 'days')
    case 'Monthly':
      return scheduleDate.add(1, 'month')
    default:
      return scheduleDate
  }
}

export const prependIndexerString = (id) => 'indexer' + id
export const prependRulesIndexerString = (type, id) => type + id

/* export const getFlatCompaniesData = (companiesList = []) => {
  const len = companiesList.length
  let newList = []
  for (let i = 0; i < len; i++) {
    // we are removing undefined from the given array as member may not visit some pages in between,
    // in which case some would be undefined in middle of the array
    // Note: here array index is equal to page number
    if (companiesList[i]) {
      newList.push(companiesList[i])
    }
  }
  return flatten(newList)
} */

export const getCompaniesSafeNumbers = (companiesList = []) => {
  return pluck('safeNumber', companiesList)
}

export const convertJSONToFileObject = (manualUploadCompanies: Object) => {
  const companyList = manualUploadCompanies.companyIds.split('\n')
  const contentArray = companyList.map((compId) => {
    compId = compId.trim()
    if (manualUploadCompanies.supportedType === 'Safe Number' || manualUploadCompanies.supportedType === 'Connect Id') {
      return compId + ',,,,,\n'
    } else {
      return ',' + compId + ',' + manualUploadCompanies.countryCode + ',,,\n'
    }
  })
  try {
    return new File([contentArray.join('')], 'imports.csv', {type: 'text/csv'})
  } catch (e) {
    // workaround for IE and Safari as they still don't support File object
    const blob = new Blob([contentArray.join('')], {type: 'text/csv'})
    blob.filename = 'imports.csv'
    return blob
  }
}

export const getDefaultPortfolioId = (portfolios) => portfolios.filter((portfolio) => portfolio.isDefault)

export const getPortfolioName = ({activePortfolioId, portfolios}) => {
  const activePortfolio = filter(propEq('portfolioId', parseInt(activePortfolioId, 10)), portfolios)
  return activePortfolio.length > 0 ? activePortfolio[0].name : ''
}



// WEBPACK FOOTER //
// ./src/store/portfolios/util.js